import React from 'react';
import PropTypes from 'prop-types';

const CenterMessage = ({ text }) => (
    <div
        style={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
    >
        <p className="-color-tx-lt-2">{text}</p>
    </div>
);

CenterMessage.propTypes = {
    text: PropTypes.string,
};

export default CenterMessage;
